import { Datagrid, DateField, List, ResourceProps, ShowButton, TextField } from 'react-admin';

const ComplaintsList = (props: ResourceProps) => {
  return (
    <List {...props}>
      <Datagrid bulkActionButtons={false}>
        <TextField label="От кого" source="fromUser.nickname" />
        <TextField label="На кого" source="toUser.nickname" />
        <TextField label="ID Жалобы" source="id" />
        <DateField locales="rus" label="Создано" source="createdAt"/>
        <DateField locales="rus" label="Обновлено" source="updatedAt" />
        <ShowButton label="ПРОСМОТР" />
      </Datagrid>
    </List>
  );
};

export default ComplaintsList;
